<template>
  <main-input
    :submit-runner-in-main-input="apiRunnerInMainInput"
    :starting-text="($store.state.originalDocument.text && $store.state.originalDocument.text.length)
                      ? $store.state.originalDocument.text : ''"
    :lock-text="lockText"
    @edit-document-text="updateStore"
    @load-document-file="loadInputtedFile">
    <template v-if="apiRunnerInMainInput" v-slot:submit-runner>
      <api-runner :options="$store.state.preSubmissionOptions" />
    </template>
  </main-input>
</template>

<script>
// @ is an alias to /src
import MainInput from 'shared/components/MainInput/MainInput'
import ApiRunner from './ApiRunner'
import {AppConfig} from '@/appConfig'
import {getDevFrontendSettings} from 'shared/js/devMode'

export default {
  name: 'MainInputContainer',
  components: {
    MainInput,
    ApiRunner
  },
  props: ['lockText'],
  computed: {
    apiRunnerInMainInput () {
      return !(AppConfig.PRE_SUBMISSION_OPTIONS_TO_SHOW.ONLY_GENRE)
        && !(AppConfig.PRE_SUBMISSION_OPTIONS_TO_SHOW.ALL)
        && !(getDevFrontendSettings('abbreviation')?.documentSettingsPane)
    }
  },
  methods: {
    updateStore (areaText) {
      this.$store.commit('EDIT_DOCUMENT_TEXT', {text: areaText, nullifySource: true})
    },
    loadInputtedFile (sourceAndTextObj) {
      // saves information about the source file
      this.$store.commit('LOAD_DOCUMENT_FILE', sourceAndTextObj.source)
      // updates the text in the store - this is a separate commit because it also applies to direct text entry, not just files
      this.$store.commit('EDIT_DOCUMENT_TEXT', {text: sourceAndTextObj.docText, nullifySource: false})
    }
  },
  mounted () {
    if (this.lockText) {
      document.getElementById('text-load-msg').style.display="block"
      setTimeout(function(){
        document.getElementById('text-load-msg').style.display="none"
      }, 2000)
    } 
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* DocumentSettings-specific CSS goes here */
</style>
